// extracted by css-extract-rspack-plugin
export default {"root":"AXyvKtpPP8fh9vuE","titleRow":"CPsQl_DAgzwmsI4E","title":"QzOW2DfSLU2slMlz","actions":"GRfJse1i9AHqKoHZ","subtitle":"mWaZaMHPWcgPYOAq"};